import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "breadcrumbs" }
const _hoisted_2 = { class: "crumbs" }
const _hoisted_3 = { class: "list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "separator"
}

export function render(_ctx, _cache) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "el-zoom-in-bottom" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (entry, index) => {
              return (_openBlock(), _createElementBlock("span", {
                class: "entry",
                onClick: $event => (_ctx.onCrumbSelect(index))
              }, [
                _createTextVNode(_toDisplayString(entry[0]) + " ", 1),
                (index < _ctx.breadcrumbs.length-1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "/"))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_4))
            }), 256))
          ])
        ], 512), [
          [_vShow, _ctx.showBreadcrumbs && !_ctx.isLoading]
        ])
      ]),
      _: 1
    })
  ], 512)), [
    [_vShow, !_ctx.isLoading]
  ])
}